// @ts-nocheck

import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import { Card, FormControl, Select, MenuItem } from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import Table from "../../components/tables/table";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SoftButton from "../../components/common/softButton";
import { toast } from "react-toastify";
import {
  deleteOtherService,
  getOtherServices,
} from "../../features/otherServices";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import ActionMenu from "../../components/common/custom/action-menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const OtherService = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { otherServices, status } = useSelector(
    (state: any) => state.otherService
  );
  const [language, setLanguage] = useState("en");

  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  // // // console.log(otherServices, 'ourService');

  const handleDelete = (id: string) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this other service?"
    );
    if (isConfirmed) {
      dispatch(deleteOtherService(id))
        .then((res) => {
          toast.success(res.payload.message);
          dispatch(
            getOtherServices({
              page: pageIndex,
              limit: pageSize,
              lan: language,
            })
          );
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const columns = [
    {
      header: "Icon",
      accessorKey: "icon", // Assuming `photo` contains the image URL or base64
      id: "icon",
      align: "center",
      cell: (info: any) => (
        <img
          src={`${info.getValue()}`}
          alt="Room Service Thumbnail"
          style={{ width: "50px", height: "50px", objectFit: "cover" }}
        />
      ),
    },
    {
      header: "Title",
      accessorKey: "title",
      id: "title",
      align: "left",
      cell: (info: any) => <strong>{info.getValue()}</strong>,
    },
    {
      header: "Key",
      accessorKey: "key",
      id: "key",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Order Type",
      accessorKey: "order_type",
      id: "order_type",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Is Visible",
      accessorKey: "is_visible",
      id: "is_visible",
      align: "left",
      cell: (info: any) => <span>{info.getValue() ? "True" : "False"}</span>,
    },
    // {
    //   header: "Actions",
    //   id: "actions",
    //   align: "center",
    //   cell: (info: any) => {
    //     const id = info.row.original.slug; // Access the room service id
    //     return (
    //       <div>
    //         <IconButton
    //           className="icon_color"
    //           onClick={() => navigate(`/other-services/edit/${id}`)}
    //         >
    //           <FaEdit />
    //         </IconButton>
    //         <IconButton className="icon_color" onClick={() => handleDelete(id)}>
    //           <MdDelete />
    //         </IconButton>
    //       </div>
    //     );
    //   },
    // },
    {
      header: "Actions",
      id: "actions",
      align: "center",
      cell: (info: any) => {
        const id = info.row.original.slug; // Access the room service id
        return (
          <div>
            <ActionMenu>
              <MenuItem onClick={() => navigate(`/other-services/edit/${id}`)}>
                  Edit
              </MenuItem>

              <MenuItem onClick={() => handleDelete(id)}>
                Delete
              </MenuItem>
            </ActionMenu>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(
      getOtherServices({ page: pageIndex, limit: pageSize, lan: language })
    );
  }, [dispatch, pageIndex, pageSize, language]);

  useEffect(() => {
    if (status && otherServices && otherServices?.data) {
      setData(otherServices.data);
      setTotalRows(otherServices.pagination.total || 0);
    }
  }, [status, otherServices]);

  return (
    <DashboardLayout className="language-box">
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
            >
              <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
                Other Service Management
              </SoftTypography>
              <SoftBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
                width="40%"
              >
                <FormControl
                  sx={{
                    marginRight: "10px",
                    minWidth: "160px",
                  }}
                  size="small"
                >
                  <Select
                    labelId="user-type-label"
                    id="language"
                    name="language"
                    value={language}
                    label="Language"
                    onChange={(e) => setLanguage(e.target.value)}
                    IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
                  >
                    <MenuItem value={"en"} sx={{ marginBottom: "5px" }}>
                      English
                    </MenuItem>
                    <MenuItem value={"ar"}>Arabic</MenuItem>
                  </Select>
                </FormControl>
                <SoftButton
                  onClick={() => navigate("/other-services/add")}
                  variant="contained"
                  color="final"
                >
                  Add Other Service
                </SoftButton>
              </SoftBox>
            </SoftBox>
            <Table
              columns={columns}
              data={data}
              pageIndex={pageIndex}
              pageSize={pageSize}
              totalRows={totalRows}
              onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            />
          </Card>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
};

export default OtherService;
